module.exports = __webpack_public_path__ + "static/media/dd59306c-f961-4578-8746-75d18dc985ac.5fdcb9b6.webp";